import React from 'react';
import { Card } from '@material-ui/core';
import CBXFooter from './CBXFooter';
import HeaderRoot from './HeaderRoot';
import { primary } from '../../styles/colors';

const LoggedLayoutRoot = ({ children, title }) => (
	<div style={{ height: '100%', width: '100%' }}>
		<HeaderRoot />
		<Card style={{
			margin: 'auto',
			width: '90%',
			padding: '2em',
			marginTop: '1em',
			marginBottom: '1em',
			height: 'calc( 100% - 6em )'
		}}>
			{title &&
				<div
					style={{
						color: primary,
						maxWidth: ' calc(100% - 2em)',
						overflow: 'hidden',
						whiteSpace: 'nowrap',
						textOverflow: 'ellipsis',
						marginLeft: '1em',
						marginRight: '1em',
						fontStyle: 'italic',
						fontFamily: 'Lato',
						fontSize: '28px',
						marginBottom: '1.5em'
					}}>
					<div>
						{title}
					</div>
				</div>
			}
			{children}
		</Card>
		<CBXFooter styles={{}} />
	</div>

);

export default LoggedLayoutRoot;
